import { Table, TableContainer, TableHead, TableRow, TableBody, IconButton, Pagination, Stack, TextField, InputAdornment, Select, SelectChangeEvent, MenuItem, FormControl, InputLabel } from "@mui/material";
import { SwitchContainerGTS } from "../../atoms/Controls/SwitchGTS";
import ButtonGST from "../../atoms/Controls/ButtonGTS";
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/es-mx'
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StyledTableCell, StyledTableRow } from "../../atoms/tables/TableStyles"
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getServiceData } from "../../store/global-services";
import { IGlobalPoprop, IServiceData } from "../../interfaces/global-interface";
import { UrlSiteBase, formatDateFromStr } from '../../Global';
let { UrlBase } = UrlSiteBase();

const ListadoVentas = (globalProp?: IGlobalPoprop) => {
    const [ventas, setVentas] = useState<any[]>([]);
    const [textSearch, setVentaBusqueda] = useState<string>('');  
    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [dateSearch, setDateSearch] = useState<Dayjs | null>();
    const [distribuidoras, setDistribuidoras] = useState<any>([]);
    const [distribuidora, setDistribuidora] = useState('0');
    const [showDistribuidoras, setShowDistribuidoras] = useState(localStorage.getItem('idPerfil') === '1');
    const navigate = useNavigate();
    const handleClick = (idVenta: number) => {
        navigate(idVenta > 0 ? `${UrlBase}Venta/${idVenta}` : `${UrlBase}Venta`);
    };
    const handlePaginationChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };
    const handleSearchTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        setVentaBusqueda(value);
    }
    const handleSearchDateChange = (date: Dayjs | null) => {
        setDateSearch(date);
        getVentas(1, date);    
    }
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') { 
            getVentasSearch(); 
            event.preventDefault(); 
        }
    };
    const handleSelectChange = (event: SelectChangeEvent<string>) => {
        const { name, value } = event.target;
        setDistribuidora(value);
        getVentas(1, null, value);
    }
    const getVentasSearch = () => {
        getVentas(1);
    }
    const getVentas = (page: number, dateParam?: Dayjs | null, idDistribuidora?: string) => {
        let dataService: IServiceData  = { nombre: 'ventas' };
        let paramService = {};
        if (page > 1) 
            paramService = { ...paramService, 'page': page };
        if (textSearch.trim().length > 0)
            paramService = { ...paramService, 'search': textSearch.trim() };
        if (dateParam)
            paramService = { ...paramService, 'date': dateParam.format('YYYY-MM-DD') };
        else if (dateSearch)
            paramService = { ...paramService, 'date': dateSearch.format('YYYY-MM-DD') };
        if (idDistribuidora)
            paramService = { ...paramService, 'idDistribuidora': idDistribuidora };
        dataService = { ...dataService, 'parametros': paramService };
        getServiceData(dataService).then(data => {
          if (data.success && data.ventas)
            setVentas([...data.ventas]);
            setTotalPages(data.pagination.last_page);
        });
    }
    useEffect(() => {
        getVentas(page);
    }, [page]);
    useEffect(() => {
        getServiceData({ nombre: 'distribuidoras', parametros: {estatus: 1}}).then(data => {
          if (data.success && data.distribuidoras)
            setDistribuidoras([...data.distribuidoras]);
        });
    }, []);
    return (
        <>
            <div className="panel-search flex">
           
                <TextField id="search" onChange={handleSearchTextChange} value={textSearch} label="Buscar" color="secondary"
                InputProps={{ endAdornment: 
                    <InputAdornment position="end">
                    <IconButton onClick={getVentasSearch}>
                        <SearchIcon />
                    </IconButton>
                    </InputAdornment> }} onKeyDown={handleKeyDown}/>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es-mx">
                    <DemoContainer components={['MobileDatePicker']}>
                        <MobileDatePicker label="Fecha Venta" value={dateSearch} maxDate={dayjs()} onChange={handleSearchDateChange}  closeOnSelect={true}/>
                    </DemoContainer>
                </LocalizationProvider>
                { !showDistribuidoras ? <></> :
                    <FormControl className="select-control">
                        <InputLabel id="distribuidora-label">Distribuidora</InputLabel>
                        <Select className='distribuidora' labelId="Distribuidora" id="distribuidora" name="idDistribuidora" value={distribuidora} label="Distribuidora" onChange={handleSelectChange}>
                                <MenuItem value={0}>Distribuidora</MenuItem>
                                {distribuidoras?.map((distribuidora: any) => (
                                <MenuItem key={"item-" + distribuidora?.id} value={distribuidora?.id}>{distribuidora?.nombre}</MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                }
            </div>
            <div className="panel-actions">
                <ButtonGST onClick={() =>handleClick(0)}>Agregar <AddIcon /></ButtonGST>
            </div>
            <TableContainer>
                <Table className="table-gts">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Distribuidora</StyledTableCell>
                            <StyledTableCell>Cliente</StyledTableCell>
                            <StyledTableCell>Fecha Venta</StyledTableCell>
                            <StyledTableCell className="movile-hidden">Total</StyledTableCell>
                            <StyledTableCell className="movile-hidden">Productos</StyledTableCell>
                            <StyledTableCell className="movile-hidden">Almacenaje</StyledTableCell>
                            <StyledTableCell>Activo</StyledTableCell>
                            <StyledTableCell >Acciones</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {ventas?.map((venta: any) => (
                            <StyledTableRow key={venta.id}>
                                <StyledTableCell>{venta?.idDistribuidora == 0 ? 'Sin Distribuidora' : venta?.distribuidora}</StyledTableCell>
                                <StyledTableCell>{venta?.idCliente == 0 ? 'Venta de Mostrador' : venta?.cliente}</StyledTableCell>
                                <StyledTableCell>{formatDateFromStr(venta?.fechaVenta)}</StyledTableCell>
                                <StyledTableCell className="movile-hidden">{venta?.importeTotalIVA	}</StyledTableCell>
                                <StyledTableCell className="movile-hidden">{venta?.totalProductos}</StyledTableCell>
                                <StyledTableCell className="movile-hidden"><SwitchContainerGTS checked={venta?.ventaAlmacenada === 1}  /></StyledTableCell>
                                <StyledTableCell><SwitchContainerGTS checked={venta?.estatus === 1}  /></StyledTableCell>
                                <StyledTableCell>
                                    <ButtonGST onClick={() => handleClick(venta.id)}><EditIcon /></ButtonGST>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))} 
                    </TableBody>
                </Table>
            </TableContainer>
            { totalPages > 1 ?
                <Stack spacing={2}>
                <Pagination count={totalPages} page={page} onChange={handlePaginationChange} />
                </Stack>
                : <></>
            }
        </>
    )
};

export default ListadoVentas;
    